// AUTO-GENERATED by apps/api/scripts/extract-landing-palettes.ts
// Do not edit by hand — re-run the script when the landing portraits
// change.

import type { EmberColorPalette } from '@athrelaris/shared';

export interface LandingPalette {
  id: 'earth' | 'water' | 'fire' | 'air';
  palette: EmberColorPalette;
}

export const LANDING_PALETTES: LandingPalette[] = [
  {
    "id": "earth",
    "palette": {
      "bgDeepHex": "#3c342c",
      "bgHex": "#453c32",
      "surfaceHex": "#4e4339",
      "surfaceElevatedHex": "#594e42",
      "textBrightHex": "#f3f2ec",
      "textPrimaryHex": "#e7e4d9",
      "textSoftHex": "#d4ceba",
      "textSecondaryHex": "#bcb394",
      "textTertiaryHex": "#9d8f62",
      "textDeepHex": "#706748",
      "textDeepestHex": "#484332",
      "accentHex": "#cfbf6e",
      "accentStrongHex": "#e3daab",
      "hairlineRgba": "rgba(185, 173, 131, 0.45)",
      "bgDeepRgb": "60 52 44",
      "bgRgb": "69 60 50",
      "surfaceRgb": "78 67 57",
      "surfaceElevatedRgb": "89 78 66",
      "textBrightRgb": "243 242 236",
      "textPrimaryRgb": "231 228 217",
      "textSoftRgb": "212 206 186",
      "textSecondaryRgb": "188 179 148",
      "textTertiaryRgb": "157 143 98",
      "textDeepRgb": "112 103 72",
      "textDeepestRgb": "72 67 50",
      "accentRgb": "207 191 110",
      "accentStrongRgb": "227 218 171"
    }
  },
  {
    "id": "water",
    "palette": {
      "bgDeepHex": "#272320",
      "bgHex": "#2f2b27",
      "surfaceHex": "#38322e",
      "surfaceElevatedHex": "#433c37",
      "textBrightHex": "#ecf3f3",
      "textPrimaryHex": "#d9e7e7",
      "textSoftHex": "#bad4d4",
      "textSecondaryHex": "#94bcbc",
      "textTertiaryHex": "#629d9d",
      "textDeepHex": "#487070",
      "textDeepestHex": "#324848",
      "accentHex": "#6ebbcf",
      "accentStrongHex": "#abd8e3",
      "hairlineRgba": "rgba(131, 185, 185, 0.45)",
      "bgDeepRgb": "39 35 32",
      "bgRgb": "47 43 39",
      "surfaceRgb": "56 50 46",
      "surfaceElevatedRgb": "67 60 55",
      "textBrightRgb": "236 243 243",
      "textPrimaryRgb": "217 231 231",
      "textSoftRgb": "186 212 212",
      "textSecondaryRgb": "148 188 188",
      "textTertiaryRgb": "98 157 157",
      "textDeepRgb": "72 112 112",
      "textDeepestRgb": "50 72 72",
      "accentRgb": "110 187 207",
      "accentStrongRgb": "171 216 227"
    }
  },
  {
    "id": "fire",
    "palette": {
      "bgDeepHex": "#25211e",
      "bgHex": "#2d2925",
      "surfaceHex": "#36302c",
      "surfaceElevatedHex": "#413a35",
      "textBrightHex": "#f7f2e9",
      "textPrimaryHex": "#eee6d3",
      "textSoftHex": "#ddcfb0",
      "textSecondaryHex": "#c7b48a",
      "textTertiaryHex": "#a38d5c",
      "textDeepHex": "#706348",
      "textDeepestHex": "#484132",
      "accentHex": "#cf916e",
      "accentStrongHex": "#e3bfab",
      "hairlineRgba": "rgba(185, 168, 131, 0.45)",
      "bgDeepRgb": "37 33 30",
      "bgRgb": "45 41 37",
      "surfaceRgb": "54 48 44",
      "surfaceElevatedRgb": "65 58 53",
      "textBrightRgb": "247 242 233",
      "textPrimaryRgb": "238 230 211",
      "textSoftRgb": "221 207 176",
      "textSecondaryRgb": "199 180 138",
      "textTertiaryRgb": "163 141 92",
      "textDeepRgb": "112 99 72",
      "textDeepestRgb": "72 65 50",
      "accentRgb": "207 145 110",
      "accentStrongRgb": "227 191 171"
    }
  },
  {
    "id": "air",
    "palette": {
      "bgDeepHex": "#252222",
      "bgHex": "#2d2929",
      "surfaceHex": "#353131",
      "surfaceElevatedHex": "#403a3a",
      "textBrightHex": "#eaf4f6",
      "textPrimaryHex": "#d4e8ec",
      "textSoftHex": "#b1d5dd",
      "textSecondaryHex": "#8abcc7",
      "textTertiaryHex": "#5c96a3",
      "textDeepHex": "#486970",
      "textDeepestHex": "#324448",
      "accentHex": "#6ebdcf",
      "accentStrongHex": "#abd9e3",
      "hairlineRgba": "rgba(131, 175, 185, 0.45)",
      "bgDeepRgb": "37 34 34",
      "bgRgb": "45 41 41",
      "surfaceRgb": "53 49 49",
      "surfaceElevatedRgb": "64 58 58",
      "textBrightRgb": "234 244 246",
      "textPrimaryRgb": "212 232 236",
      "textSoftRgb": "177 213 221",
      "textSecondaryRgb": "138 188 199",
      "textTertiaryRgb": "92 150 163",
      "textDeepRgb": "72 105 112",
      "textDeepestRgb": "50 68 72",
      "accentRgb": "110 189 207",
      "accentStrongRgb": "171 217 227"
    }
  }
];
